import "../shared/auth-client.js";

let isToolbarExpanded = true;
let currentZoomLevel = 1.0;
let authReady = false;
let currentUrl = "";
let renderedSrc = "";

const SAVED_URL_KEY = "savedWebGLUrl";
const BRIDGE_URL = (window.LSAuth && window.LSAuth.config.bridgeUrl) || "http://localhost:18088";

Office.onReady((info) => {
    if (info.host !== Office.HostType.PowerPoint) return;

    bindToolbar();
    bindLockedActions();
    fitLockedCanvas();

    boot();
});

// Office.js 未加载成功时也保证锁定页按加载项尺寸缩放
fitLockedCanvas();
window.addEventListener("resize", fitLockedCanvas);

function boot() {
    // 先取到课件地址，再决定加载还是显示未登录锁定页
    resolveTargetUrl().then(url => {
        currentUrl = url;
        return window.LSAuth.init();
    }).then(state => {
        authReady = true;
        applyAuthState(state);
    }).catch(err => {
        console.error("初始化失败", err);
        authReady = true;
        applyAuthState({ loggedIn: false, bridgeOnline: false });
    });

    window.LSAuth.onChange(state => {
        if (authReady) applyAuthState(state);
    });
    window.LSAuth.startWatching();
}

// ========================
// 登录状态驱动的视图
// ========================
function applyAuthState(state) {
    if (state && state.loggedIn) {
        hideLockedView();
        hideMessage();
        if (currentUrl) {
            renderWebGL(currentUrl, state.token);
        } else {
            showMessage("No Courseware Selected", "Please select courseware from the Lively Science panel on the right.", false);
        }
        return;
    }

    // 未登录：停止播放，显示 Figma 的 "AR Courseware Locked" 页面
    clearViewer();
    hideMessage();
    showLockedView();
}

function showLockedView() {
    const view = document.getElementById("locked-view");
    if (!view) return;
    view.style.display = "flex";
    fitLockedCanvas();
}

function hideLockedView() {
    const view = document.getElementById("locked-view");
    if (view) view.style.display = "none";
}

// 让 803×480 设计稿画布等比适配加载项尺寸
function fitLockedCanvas() {
    const view = document.getElementById("locked-view");
    if (!view) return;
    const canvas = view.querySelector(".locked-canvas");
    if (!canvas) return;

    const scale = Math.min(view.clientWidth / 803, view.clientHeight / 480, 1);
    canvas.style.transform = "translate(-50%, -50%) scale(" + scale + ")";
}

function bindLockedActions() {
    const btn = document.getElementById("btn-locked-signin");
    if (btn) btn.onclick = requestHostLogin;
}

/**
 * 不在加载项里做登录表单，直接唤起 VSTO 的登录窗口。
 * 登录成功后认证桥状态变化，轮询会自动切到播放器。
 */
function requestHostLogin() {
    const btn = document.getElementById("btn-locked-signin");
    const hint = document.getElementById("locked-hint");
    if (hint) hint.textContent = "";
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Opening…";
    }

    const reset = () => {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = "Sign in";
    };

    window.LSAuth.requestHostLogin().then(
        result => {
            if (!result || result.ok !== true) throw new Error("bad response");
            // 登录窗口已由 VSTO 打开，等待 /auth/state 变化
            setTimeout(reset, 800);
        },
        () => {
            if (hint) {
                hint.textContent = "Unable to open the login window. Please ensure the Lively Science PPT Plugin is installed and running.";
            }
            reset();
        }
    );
}

function showMessage(title, desc, showDownload) {
    document.getElementById("msg-title").innerText = title;
    document.getElementById("msg-desc").innerText = desc;
    document.getElementById("msg-link").style.display = showDownload ? "inline-block" : "none";
    document.getElementById("msg-overlay").style.display = "flex";
    hideLockedView();
}

function hideMessage() {
    document.getElementById("msg-overlay").style.display = "none";
}

// ========================
// 课件地址解析
// ========================
function resolveTargetUrl() {
    return new Promise(resolve => {
        let saved = "";
        try {
            saved = Office.context.document.settings.get(SAVED_URL_KEY) || "";
        } catch (e) {
            saved = "";
        }
        if (saved) {
            resolve(stripToken(saved));
            return;
        }

        // 空画框：向 VSTO 本地服务请求最近一次选择的课件
        fetchWithTimeout(BRIDGE_URL + "/", {}, 1500)
            .then(response => response.text())
            .then(text => {
                const url = (text || "").trim();
                if (!url) {
                    resolve("");
                    return;
                }
                try {
                    Office.context.document.settings.set(SAVED_URL_KEY, url);
                    Office.context.document.settings.saveAsync();
                } catch (e) {
                    /* 忽略保存失败 */
                }
                resolve(stripToken(url));
            })
            .catch(() => resolve(""));
    });
}

function fetchWithTimeout(url, options, timeout) {
    return new Promise((resolve, reject) => {
        let controller = null;
        try {
            if (typeof AbortController !== "undefined") controller = new AbortController();
        } catch (e) {
            controller = null;
        }
        const opts = options || {};
        if (controller) opts.signal = controller.signal;
        const timer = setTimeout(() => {
            if (controller) controller.abort();
            reject(new Error("timeout"));
        }, timeout);
        fetch(url, opts).then(
            response => {
                clearTimeout(timer);
                resolve(response);
            },
            error => {
                clearTimeout(timer);
                reject(error);
            }
        );
    });
}

function stripToken(url) {
    if (url.indexOf("token=") < 0) return url;
    try {
        const parsed = new URL(url, window.location.href);
        parsed.searchParams.delete("token");
        return parsed.toString();
    } catch (e) {
        return String(url).replace(/([?&])token=[^&]*&?/g, "$1").replace(/[?&]$/, "");
    }
}

/**
 * 播放器地址里的 token 必须是“当前查看者”的 token：
 * 插入 PPT 时 payload.token 故意留空，这里在播放前注入。
 * 同时兼容旧格式（直接拼 token= 查询参数）。
 */
function buildPlayableUrl(url, token) {
    if (!token) return url;

    try {
        const parsed = new URL(url, window.location.href);

        if (parsed.searchParams.has("play")) {
            const payload = JSON.parse(parsed.searchParams.get("play"));
            payload.token = token;
            setQueryParam(parsed, "play", JSON.stringify(payload));
            return parsed.toString();
        }

        // 兼容 #/play?play=... 这种 hash 形式
        const hash = parsed.hash || "";
        const marker = "play=";
        const index = hash.indexOf(marker);
        if (index >= 0) {
            const prefix = hash.substring(0, index + marker.length);
            let value = hash.substring(index + marker.length);
            let suffix = "";
            const amp = value.indexOf("&");
            if (amp >= 0) {
                suffix = value.substring(amp);
                value = value.substring(0, amp);
            }
            const payload = JSON.parse(decodeURIComponent(value));
            payload.token = token;
            parsed.hash = prefix + encodeURIComponent(JSON.stringify(payload)) + suffix;
            return parsed.toString();
        }
    } catch (e) {
        console.warn("Failed to inject token into play payload:", e);
    }

    // 旧格式：没有 play payload 时沿用 token= 查询参数
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "token=" + encodeURIComponent(token);
}

// 用 %20 而不是 + 编码 play JSON，和 Android 端的 encodeURIComponent 保持一致
function setQueryParam(parsed, key, value) {
    const pairs = [];
    parsed.searchParams.forEach((v, k) => {
        if (k !== key) pairs.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
    });
    pairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    parsed.search = pairs.join("&");
}

// ========================
// 播放器
// ========================
function renderWebGL(url, token) {
    const iframe = document.getElementById("unity-iframe");
    const src = buildPlayableUrl(url, token);
    if (src === renderedSrc) return;
    renderedSrc = src;
    iframe.src = src;
    hideMessage();
    hideLockedView();
    document.getElementById("floating-toolbar").style.display = "flex";
    document.getElementById("collapsed-btn").style.display = "none";
    isToolbarExpanded = true;
}

function clearViewer() {
    const iframe = document.getElementById("unity-iframe");
    if (renderedSrc) {
        iframe.src = "about:blank";
        renderedSrc = "";
    }
    document.getElementById("floating-toolbar").style.display = "none";
    document.getElementById("collapsed-btn").style.display = "none";
}

// ========================
// 工具栏
// ========================
function bindToolbar() {
    document.getElementById("btn-zoom-in").onclick = zoomIn;
    document.getElementById("btn-zoom-out").onclick = zoomOut;
    document.getElementById("btn-hide").onclick = toggleToolbar;
    document.getElementById("btn-show").onclick = toggleToolbar;
}

function toggleToolbar() {
    const toolbar = document.getElementById("floating-toolbar");
    const collapsedBtn = document.getElementById("collapsed-btn");

    if (isToolbarExpanded) {
        toolbar.style.display = "none";
        collapsedBtn.style.display = "flex";
    } else {
        if (renderedSrc) toolbar.style.display = "flex";
        collapsedBtn.style.display = "none";
    }
    isToolbarExpanded = !isToolbarExpanded;
}

function zoomIn() {
    currentZoomLevel += 0.1;
    applyZoom();
}

function zoomOut() {
    if (currentZoomLevel > 0.3) {
        currentZoomLevel -= 0.1;
        applyZoom();
    }
}

function applyZoom() {
    document.getElementById("iframe-container").style.transform = "scale(" + currentZoomLevel + ")";
}
